import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BaseLayout from "../../layouts/base/base_layout";
import Loading from "../../components/loading/loading";
import { Box, Grid, Typography } from "@mui/material";
import Session from "../../utils/session";
import useUser from "../../providers/user/user_provider";

export default function Authorize() {
  const [isLoading, setLoading] = useState<boolean>(false);
  const { login, userPermissions, loading } = useUser();
  const { search, state } = useLocation();
  const queryparams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  );
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
    const accessToken = queryparams.get("accessToken");
    const refreshToken = queryparams.get("refreshToken");

    if (accessToken && refreshToken) {
      setLoading(true);
      Session.login(accessToken, refreshToken);
      login(accessToken, refreshToken);
    } else {
      navigate("/", { replace: true });
    }
  }, [queryparams, navigate, login]);

  useEffect(() => {
    if (!loading && userPermissions) {
      let module = userPermissions?.permissions?.[0]?.module;
      if (module === 'choices') {
        module = 'surveys';
      }
      let nav = "/" + `${module}`;
      navigate(nav, { replace: true });
    }
  }, [loading, userPermissions, navigate]);

  return (
    <BaseLayout>
      <Box
        height={"100vh"}
        width="100vw"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box mb={1.5}>
          <Loading minHeight={0} />
        </Box>
        <Typography variant="body1">Authorizing...</Typography>
      </Box>
    </BaseLayout>
  );
}
